import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const storageKey = {
  TOKEN: 'token',
  IS_LOGGED_IN_BACK: 'isLoggedInBack',
  IS_WELCOME_SIGN_UP: 'isWelcomeSignUp',
};

export const storage = {
  setToken: (token: string) => localStorage.setItem(storageKey.TOKEN, token),

  getToken: () => localStorage.getItem(storageKey.TOKEN),

  removeToken: () => localStorage.removeItem(storageKey.TOKEN),

  setNextRequestOtpAt: (route: string, time: string) => cookies.set(route, time),

  getNextRequestOtpAt: (route: string) => cookies.get(route),

  setKeyValue: (key: string, value: unknown) => localStorage.setItem(key, value as string),

  getKeyValue: (key: string) => localStorage.getItem(key),

  removeStorageKey: (key: string) => localStorage.removeItem(key),

  listenStorageChange: (callback: (params: { name: string; value?: string }) => void) => {
    cookies.addChangeListener(callback);
  },

  removeChangeListener: (callback: (params: { name: string; value?: string }) => void) => {
    cookies.removeChangeListener(callback);
  },

  get isLoggedIn() {
    return !!this.getToken();
  },
};
